export default "__VITE_ASSET__ht7LQwBt__"